import { getSpaceValue } from '../../../designSystem'

export const FLAT_SELECT_CONFIG = {
  optionGap: getSpaceValue('s8'),
}
